import React from 'react';
import ZiggeoVideoPlayer from 'components/ui/ZiggeoVideo/ZiggeoVideoPlayer';
import ZiggeoMediaPlayer from 'components/ui/ZiggeoVideo/ZiggeoMediaPlayer';
import RecordingEmbed from 'components/Practice/shared/RecordingEmbed';

const Player = props => {
  const {
    recording,
    hasZiggeoForAllMedia,
    ziggeoApiKey,
    customClass,
    customIframeClass,
  } = props;

  switch (recording.provider) {
    case 'ziggeo':
      if (hasZiggeoForAllMedia)
        return (
          <ZiggeoMediaPlayer
            token={recording.externalId}
            apiKey={ziggeoApiKey}
            className="VideoEmbed-videoPlayer maxh-600"
          />
        );
      return (
        <ZiggeoVideoPlayer
          token={recording.externalId}
          apiKey={ziggeoApiKey}
          className="VideoEmbed-videoPlayer"
        />
      );
    case 'hippo_video':
    case 'ilos':
      return (
        <div className={customClass}>
          <RecordingEmbed
            className={customIframeClass}
            embedUrl={recording.url}
          />
        </div>
      );
    default:
      return <div />;
  }
};

export default Player;
